export enum ErrorRouteNames {
  MaintenancePage = 'MaintenancePage',
  NotFoundPage = 'NotFoundPage',
  SystemErrorPage = 'SystemErrorPage',
  NotFoundPageADO = 'NotFoundPageADO',
}

const routes = [
  {
    path: '/maintenance',
    name: ErrorRouteNames.MaintenancePage,
    meta: {
      publicRoute: true,
    },
    components: {
      header: null,
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      default: () => import('@client/pages/MaintenancePage.vue'),
      footer: null,
    },
  },
  {
    path: '/not-found',
    alias: '/404',
    name: ErrorRouteNames.NotFoundPage,
    meta: {
      publicRoute: true,
    },
    components: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      default: () => import('@client/pages/errors/NotFoundPage.vue'),
    },
    props: {
      default: true,
      header: {showSecondaryHeader: false},
    },
  },
  {
    path: '/error',
    alias: '/500',
    name: ErrorRouteNames.SystemErrorPage,
    meta: {
      publicRoute: true,
    },
    components: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      default: () => import('@client/pages/errors/SystemErrorPage.vue'),
      header: null,
    },
  },
  {
    path: '/not-found',
    alias: '/404',
    name: ErrorRouteNames.NotFoundPageADO,
    meta: {
      publicRoute: true,
    },
    components: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      default: () => import('@client/pages/errors/404NotFoundADO.vue'),
      header: () => import('@client/components/onboarding/OnboardingHeader.vue'),
    },
  },
];

export default routes;
